import { AuthActions, AuthState } from './types';

import ActionTypes from './constants';
import produce from 'immer';

export const initialState: AuthState = {
  isLogin: !!window.localStorage.getItem('token'),
  error: '',
  isSubmitting: false,
  user: null,
  userIsLoading: false,
};

const authReducer = (
  state: AuthState = initialState,
  action: AuthActions,
): AuthState =>
  produce(state, draft => {
    switch (action.type) {
      case ActionTypes.LOG_IN:
        draft.isSubmitting = true;
        draft.error = '';
        break;
      case ActionTypes.LOG_OUT:
        draft.isLogin = false;
        draft.error = '';
        break;
      case ActionTypes.LOG_IN_SUCCESS:
        draft.isSubmitting = false;
        draft.isLogin = true;
        draft.error = '';
        draft.user = action.payload;
        break;
      case ActionTypes.LOG_IN_FAILURE:
        draft.isSubmitting = false;
        draft.isLogin = false;
        draft.error = action.payload;
        break;
      case ActionTypes.FETCH_USER:
        draft.userIsLoading = true;
        break;
      case ActionTypes.FETCH_USER_SUCCESS:
        draft.userIsLoading = false;
        draft.user = action.payload;
        break;
    }
  });

export default authReducer;
